import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2620_23386)" }, [
      _createElementVNode("path", {
        fill: "#58A1D5",
        d: "M2.439 24h19.123C23.086 24 24 23.333 24 22.225c0-3.444-4.606-8.196-12.007-8.196C4.606 14.029 0 18.78 0 22.225 0 23.333.913 24 2.439 24m9.568-12.36c3.052 0 5.704-2.563 5.704-5.9A5.703 5.703 0 0 0 12.007 0C8.955 0 6.303 2.496 6.303 5.766c0 3.31 2.638 5.874 5.704 5.874"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2620_23386" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }